module.exports = __webpack_public_path__ + "static/luck_blade-d5608018a9899504959ddffd07277583.jpeg";